/**
 * Canonical list of action values used on `ConversionTracked` and related
 * Tagular events. Mirrors the `TagularAction` enum in www.edx.org
 * (`src/types/Tagular.ts`) so that funnel events stay aligned across repos.
 */
export enum TagularAction {
  STARTED = 'Started',
  COMPLETED = 'Completed',
  RECEIVED = 'Received',
  APPROVED = 'Approved',
  DECLINED = 'Declined',
  CANCELLED = 'Cancelled',
  ACTIVATED = 'Activated',
  VIEWED = 'Viewed',
  OPENED = 'Opened',
  SUBMITTED = 'Submitted',
  CONTINUE = 'Continue',
  UPGRADED = 'Upgraded',
}
